import React from 'react';
import { Form, DatePicker, TimePicker } from 'antd';
import dayjs from 'dayjs';
import AppModal from '@/pages/inside/tenant/AppModal';
import Select from '@/components/ui/Select';
import { Button } from '@/components/ui/Button';
import { CreateRoleModalBody, CreateRoleModalFooter } from '@/pages/inside/tenant/style';

export const CreateAttendanceModal = ({
    open,
    onCancel,
    form,
    onSubmit,
    employeeOptions,
    statusOptions,
    showCheckInOut,
    loading,
}) => {
    return (
        <AppModal
            size="md"
            title="Record Attendance"
            open={open}
            onCancel={onCancel}
            footer={null}
            styles={{ body: { paddingTop: 8 } }}
        >
            <CreateRoleModalBody>
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="userId"
                        label="Employee"
                        rules={[{ required: true, message: 'Select employee' }]}
                    >
                        <Select
                            placeholder="Select employee"
                            options={employeeOptions}
                            showSearch
                            optionFilterProp="label"
                        />
                    </Form.Item>
                    <Form.Item name="date" label="Date" rules={[{ required: true, message: 'Select date' }]}>
                        <DatePicker
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD"
                            disabledDate={(current) => current && current > dayjs().endOf('day')}
                        />
                    </Form.Item>
                    <Form.Item name="status" label="Status" initialValue="present">
                        <Select placeholder="Status" options={statusOptions} />
                    </Form.Item>
                    {showCheckInOut && (
                        <>
                            <Form.Item name="checkIn" label="Check in (e.g. 09:00 AM)" preserve={false}>
                                <TimePicker style={{ width: '100%' }} use12Hours format="h:mm a" />
                            </Form.Item>
                            <Form.Item name="checkOut" label="Check out (e.g. 06:00 PM)" preserve={false}>
                                <TimePicker style={{ width: '100%' }} use12Hours format="h:mm a" />
                            </Form.Item>
                        </>
                    )}
                </Form>
            </CreateRoleModalBody>
            <CreateRoleModalFooter>
                <Button $primary={false} onClick={onCancel} $padding="10px 16px" $size="14px">
                    Cancel
                </Button>
                <Button
                    $primary
                    $blackOnLight
                    onClick={onSubmit}
                    loading={loading}
                    $padding="10px 16px"
                    $size="14px"
                >
                    Record
                </Button>
            </CreateRoleModalFooter>
        </AppModal>
    );
};

export default CreateAttendanceModal;
